import { Trophy } from "lucide-react";
import type { KnownPlayerFields } from "@/lib/known-player";
import { cn } from "@/lib/utils";

export function ChallengePlayerBadge({
  player,
  compact = false,
}: {
  player: KnownPlayerFields;
  compact?: boolean;
}) {
  if (player.isKnownPlayer !== true) return null;

  const name = player.knownPlayer?.name;
  const label = name ? `Challenge-Spieler: ${name}` : "Challenge-Spieler";

  return (
    <span
      title={label}
      aria-label={label}
      className={cn(
        "inline-flex max-w-full min-w-0 items-center gap-1 rounded border border-amber-300/25 bg-amber-300/10 text-amber-200",
        compact ? "shrink-0 p-0.5" : "mt-1 px-1.5 py-0.5 text-[9px] font-bold leading-tight"
      )}
    >
      <Trophy aria-hidden="true" className="h-2.5 w-2.5 shrink-0" />
      {!compact && name && <span className="truncate font-medium">{name}</span>}
    </span>
  );
}
